<h4 mat-dialog-title class="title-update-petition">Update Petition Details
    <i (click)="onDismiss();" class="close-icon pi pi-times pull-right pointer"></i>
    <label class="d-block label-cls mt-n1" *ngIf="step2">View Generate and Print the updated details</label>
  </h4>
  <div class="pet-updt">
    <div mat-dialog-content>
      <!-------------------------------------------step1-------------------------------------------->
      <div class="step1" *ngIf="step1">
        <div class="mb-3" *ngIf="this.modify.length && this.modify[0]">
          <form #petitionUpdateForm="ngForm">
            <p class="update-petition-sub-title">Change Lawfirm</p>
            <div class="row">
              <div class="col-6 pl-0">
                <label class="label-cls d-block"> Select Lawfirm </label>
                <select name="attorney" class="select-comp" [(ngModel)]="taskUpdate.attrSelected"
                  (change)="attorneySelected()">
                  <option value="" disabled> Select Firm </option>
                  <option *ngFor="let item of attorneys" [value]="item.attorneyId">
                    {{item?.attorneyName}}
                  </option>
                </select>
              </div>
              <div class="col-6 pr-0">
                <label class="label-cls d-block"> Lawfirm Name </label>
                <select [disabled]="attorneyUsers.length === 0" [(ngModel)]="taskUpdate.preparerAttorneyId"
                  name="preparerAttorneyId" class="select-comp" (change)="attorneyUserSelected()"
                  [ngClass]="{'disabled': attorneyUsers.length === 0}">
                  <option value="0" disabled>Select Preparer</option>
                  <option *ngFor="let item of attorneyUsers" [value]="item.id">
                    {{item?.firstName +' '+item?.lastName}}
                  </option>
                </select>
              </div>
            </div>
          </form>
        </div>
        <div class="margin-n24 dot-btm mb-3" *ngIf="this.modify.length && this.modify[0] && this.modify[1]"></div>
        <div class="upgrade2premium-processng" *ngIf="this.modify.length && this.modify[1]">
          <!---premium-->
          <p class="update-petition-sub-title">Upgrade to Premium Processing</p>
          <table class="im-card-no-border-table table im-card-table-noborder-spacing" mat-table
            [dataSource]="feeDataSource">
            <ng-container matColumnDef="feetype">
              <th mat-header-cell *matHeaderCellDef> <b>Fee Type </b></th>
              <td mat-cell *matCellDef="let element"> {{element.feetype}} </td>
            </ng-container>
  
            <ng-container matColumnDef="amount">
              <th mat-header-cell *matHeaderCellDef> <b>Amount</b> </th>
              <td mat-cell *matCellDef="let element">
                <p-inputNumber name="newPetitionfee" [(ngModel)]="newPetitionfee" placeholder="Enter new fee"
                  mode="currency" *ngIf="!showFee" currency="USD" locale="en-US">
                </p-inputNumber>
                <span class="showfee" *ngIf="showFee"> ${{element.amount}}</span>
              </td>
            </ng-container>
  
            <!-- <ng-container matColumnDef="action">
                          <th mat-header-cell *matHeaderCellDef><b> Action </b></th>
                          <td mat-cell *matCellDef="let element">
                              <mat-icon matTooltip="change this fee" *ngIf ="showFee"    (click)="toggleFeeForm(false)" > edit </mat-icon>
                              <mat-icon matTooltip="Close" *ngIf ="!showFee" (click)="toggleFeeForm(true)"> close </mat-icon>
                          </td>
  
                      </ng-container> -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
  
        </div>
        <button
          [disabled]=" this.modify.length && this.modify[0] &&!(taskUpdate.attrSelected && taskUpdate.preparerAttorneyId && taskUpdate.preparerAttorneyId !== '0')"
          class="mt-3 btn btn-success" (click)="nextStep()">
          Next
        </button>
      </div>
  
      <!-------------------------------------------step2 begin-------------------------------------------->
      <div class="step2" *ngIf="step2">
        <div class="mb-3" *ngIf="this.modify.length && this.modify[1]">
          <p class="update-petition-sub-title" *ngIf="this.modify.length && this.modify[1] && this.modify[0]">Premium
            Processing</p>
          <div class="row">
            <div class="col-4">
              <p class="label-cls">Receipt Number</p>
              <div>{{ receiptNumber}}</div>
            </div>
            <div class="col-4">
              <p class="label-cls">Service Center</p>
              <div>{{serviceCenterName}} </div>
            </div>
          </div>
        </div>
        <div class="margin-n24 dot-btm mb-3" *ngIf="this.modify.length && this.modify[0] && this.modify[1]"></div>
        <div class="mb-3" *ngIf="this.modify.length && this.modify[0]">
          <p class="update-petition-sub-title" *ngIf="this.modify.length && this.modify[1] && this.modify[0]">Lawfirm Details</p>
          <div class="row">
            <div class="col-4">
              <p class="label-cls">Lawfirm</p>
              <div>{{attrFirmName}} </div>
            </div>
            <div class="col-4">
              <p class="label-cls">Preparer Name</p>
              <div>{{preparerName}} </div>
            </div>
          </div>
        </div>
        <div class="margin-n24 dot-btm mb-3"></div>
        <div class="mb-3">
          <p class="update-petition-sub-title"> Generate your cover letter</p>
          <span class="mini mb-2 ng-10">Select the template you wish to use to generate the cover letter for this
            petition
          </span>
  
          <div class="border-cvrlttr">
            <div class="template-captn pl-3 pt-2 pb-2"> Template List</div>
            <div class="p-3">
              <div>
                <ng-template [ngIf]="templates && templates.length > 0">
                  <div class="b-600 pt-1">Created Templates</div>
                  <mat-radio-group required class="flex-col ovrflw-auto coverletter-radio-text"
                    aria-label="Select an option">
                    <mat-radio-button *ngFor="let template of templates; let i=index" name="templates"
                      (change)="onCvrLtrTmpateChange($event)" [checked]="template.id === coverLetterTemplateId"
                      value="{{template.id}}">
                      {{ template.name }} {{ template.isDefault === 'true' ? 'Default' : '' }}
                    </mat-radio-button>
                  </mat-radio-group>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
        <div class="margin-n24 dot-btm mb-3"></div>
        <div class="mb-3">
          <div class="row">
            <div class="col-5 pl-0" [ngClass]="{'divider-right': this.pdfAlreadyGenerated}">
              <p class="b-600"> Generate & Print Petition</p>
              <button class="btn btn-primary"
                [ngClass]="{'disabled': !isReceiptPresent || (taskUpdate.preparerAttorneyId === ('' + task.preparerAttorneyId) && modify[0]) || isSubmitted}"
                [disabled]="!isReceiptPresent || (taskUpdate.preparerAttorneyId === ('' + task.preparerAttorneyId) && modify[0]) || isSubmitted"
                (click)="saveChanges()">Generate pdf</button>
              <label class="invalid-message d-block"
                *ngIf="(taskUpdate.preparerAttorneyId === ('' + task.preparerAttorneyId) && modify[0])">Same
                lawfirm should not be selected.</label>
              <label class="label-dark d-block" *ngIf="!isReceiptPresent"><span class="fa fa-exclamation-triangle"></span>
                No receipt notice generated</label>
            </div>
            <div class="col-7 pr-0" *ngIf="this.pdfAlreadyGenerated">
              <p class="b-600">PDF Generated on {{ pdfGeneratedDate }}</p>
              <button class="btn btn-primary" (click)="viewPDF()">Print pdf</button>
            </div>
          </div>
        </div>
        <div class="margin-n24 dot-btm mb-3"></div>
        <div>
          <button type="button" *ngIf="!isSubmitted" class="float-left btn btn-primary"
            (click)="backToStepOne()">Back</button>
          <button type="button" class="float-right button_bg-gray" (click)="onDismiss()">
            Close
          </button>
        </div>
      </div>
      <!-------step2  end----->
    </div>
  </div>
  